// input.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsInputComponent } from './input.component';

@NgModule({
  declarations: [AsInputComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule ],
  exports: [AsInputComponent]
})
export class AsInputModule {}
